import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-form-control',
    templateUrl: 'form-control.component.html',
    styleUrls: ['form-control.component.scss'],
    standalone: false
})
export class FormControlComponent {
  private privateClasses: string;

  @Input() control;
  @Input() markAsDirty;
  @Input() errors;

  @Input('classes')
  set classes(value: string) {
    this.privateClasses = value;
  }

  get classes() {
    return this.privateClasses || 'validate-error';
  }

  hasError(error) {
    if (error.parent && this.control.parent) {
      return this.control.parent.hasError(error.name);
    }

    return this.control.hasError(error.name);
  }
}
